module.exports = __webpack_public_path__ + "img/screen-background.0f3a9a79.svg";